import React from 'react';
import { Link } from 'react-router-dom';

const NormalHeader: React.FC = () => {
  return (
    <header className="w-full border-b border-gray-200 bg-white">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6">
        <Link to="/lp" className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-full bg-gradient-to-br from-brand-primary to-brand-accent" />
          <div>
            <p className="text-sm font-semibold text-gray-700">森近クリニック</p>
            <p className="text-xs text-gray-500">カウンセリング予約</p>
          </div>
        </Link>
        <nav className="flex items-center gap-4 text-sm text-gray-600">
          <Link to="/form/normal/form1" className="hover:text-gray-900">
            予約フォーム
          </Link>
          <Link to="/form/normal/reservations" className="hover:text-gray-900">
            予約一覧
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default NormalHeader;
